import $ from 'jquery';
import 'jquery-mask-plugin';
import 'breaky';
import './slick-carousel';
import './modules.scss';
import './accordion';
import './dropdown';
import './reveal';
import './responsive';
import './back-button';
import './cookies-banner';
import './toggle-display';
import './nav-accordion';
import './truncate';
import './product-size-change';
import './product-add-to-bag';
import './product-color-change';
import './product-oos';
import './product-remove-item';
import './switch-class';
import './hamburger';
import './fixed-header';
import './fixed-overlay';
import './fixed-scroll';
import './lazy-ajax';
import './back-to-top';
import './product-zoom';
import ImageCarousel from './image-carousel';
import slickArrow from './slick/arrow';
import './ui-tabs';
import './modal';
import './submit-modal';
import './track-video';
import './search';
import noFocus from './no-focus';
import './focus-to';
import './slides';
import './side-cart';
import './side-filter';
import './goto-slide';
import './change-toggle';
import sizeguideTable from './sizeguide';


// Jon to move into its own module and follow standards
$.fn.navDropdowns = function navDropdowns() {
  function toggleDropdown($el) {
    $el.find('ul').slideToggle('slow');
  }

  // Iterate and reformat each matched element.
  return this.each(function reformat() {
    $(this).on('click', function setupToggle() {
      toggleDropdown($(this));
    });
  });
};
window.applyTelephoneMask = () => {
  $('.js-mask-tel-us').each(function maskTelephoneNum() {
    const $el = $(this);
    // const re = new RegExp('^(d{3})sd{3}-d{4,}$');
    const options = {
      onKeyPress: () => {
        if ($el.val().length >= 15) {
          $el.mask('000000000000000', options);
        } else if ($el.val().length === 10) {
          $el.mask('(000) 000-00000', options);
        }
      },
    };
    $el.mask('(000) 000-00000', options);
  });
};
const resetReveals = () => {
  const $resettableReveal = $('.checkout__section-content .js-reveal-is-resettable.reveal-is-active');
  $resettableReveal.each(function closeChildReveals() {
    $(this).reveal('forceToggle');
  });
};
const disableReviewOrder = ($el) => {
  const $reviewTrigger = $('.js-checkout-review-section-trigger');
  $('.js-checkout-section-heds').removeClass('reveal-is-active');
  $el.closest('.js-checkout-section-heds').addClass('reveal-is-active');
  if (!$el.is($reviewTrigger)) {
    $reviewTrigger.reveal('disable');
    $('.js-tablet-place-order').addClass('u-hide');
    $('.js-checkout-total').removeClass('is-grand');
  }
};
const initReveals = () => {
  $('.js-reveal').reveal();
  $('.js-new-shipping-reveal').reveal({
    onOpen: () => {
      $('.js-checkout-shipping-detail-ctas').slideUp(275);
    },
    onClose: () => {
      $('.js-checkout-shipping-detail-ctas').slideDown(275);
    },
  });
  $('.js-new-shipping-reveal-cancel').reveal({
    onOpen: () => {
      resetReveals();
    },
    onClose: () => {
      $('.js-checkout-shipping-detail-ctas').slideDown(275);
    },
  });
  $('.js-new-payment-reveal').reveal({
    onOpen: () => {
      $('.js-checkout-payment-detail-ctas').slideUp(275);
    },
    onClose: () => {
      $('.js-checkout-payment-detail-ctas').slideDown(275);
    },
  });
  $('.js-new-payment-reveal-cancel').reveal({
    onOpen: () => {
      resetReveals();
    },
    onClose: () => {
      $('.js-checkout-payment-detail-ctas').slideDown(275);
    },
  });
  $('.js-billing-address-reveal').reveal({
    onOpen: () => {
      $('.js-billing-address').addClass('reveal-is-active');
    },
    onClose: () => {
      $('.js-billing-address').removeClass('reveal-is-active');
    },
  });
  $('.js-section-reveal').reveal({
    onOpen: ($el) => {
      resetReveals();
      disableReviewOrder($el);
    },
  });
};
const imageCarousel = () => {
  const IMAGE_CAROUSEL_SELECTOR = '.image-carousel';
  const PRODUCT_ZOOM_SELECTOR = `${IMAGE_CAROUSEL_SELECTOR}--product-zoom`;
  const $imageCarousel = $(IMAGE_CAROUSEL_SELECTOR);
  const prodName = $('.image-carousel').data('product-name');

  $imageCarousel
    .filter(`:not(${PRODUCT_ZOOM_SELECTOR})`)
    .imageCarousel();

  $imageCarousel
    .filter(PRODUCT_ZOOM_SELECTOR)
    .each(function setupZoomCarousel() {
      const carousel = new ImageCarousel(this, {
        lazyLoad: 'ondemand',
        slidesToShow: 2,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
      $(this).productZoom({
        slideFunc: carousel.setSlideNumber.bind(carousel),
        beforeUnmount: carousel.transitionSlide.bind(carousel),
        targetSelector: 'img',
      });
    });

  $('.image-carousel__dots').find('button').prepend(`${prodName}, `);
};

const removeWhiteSpacesAndLowerCase = () => {
  $('button[data-level="1"], button[data-level="2"]').each(function () {
    let cat = $(this).attr('aria-controls');
    cat = cat.replace(/ /g, '-').toLowerCase();
    cat = `${cat}-container`;
    $(this).attr('aria-controls', cat);
    $(this).next('ul').attr('id', cat);
  });
};

// Adds tabindex=-1 to .js-slick-no-focus elements
const slickResetTabIndex = ($el) => {
  // Init
  $el.find('.js-slick-no-focus').attr('tabindex', '-1');

  $el.on('afterChange', () => {
    setTimeout(() => {
      $el.find('.js-slick-no-focus').attr('tabindex', '-1');
    }, 200);
  });
};


$(document).ready(() => {
  $('#js-nav-dropdown').navDropdowns();
  $('#js-nav-dropdown--full').navDropdowns();
  $('.js-dropdown').dropdown();
  $('.js-accordion').accordion();
  $('.js-nav-accordion').navAccordion();
  $('.ui-tabs').tabs();
  $('.js-toggle-display').toggleDisplay();
  $('.js-modal').modal();
  $('.js-track-video').trackVideo();
  $('.submit-modal').submitModal();
  $('[data-truncate]').truncate();
  $('.back-button').backButton();
  $('.js-responsive').responsive();
  $('.js-site-header__wrapper').fixedHeader();
  $('.js-fixed-overlay').fixedOverlay();
  // $('.js-fixed-scroll').fixedScroll();
  $('.js-back-to-top').backToTop();
  $('.js-switch-class').switchClass();
  $('.js-hamburger').hamburger();
  $('.js-item-wrapper').removeItem();
  $('#js-bag-btn').sideCart();
  $('#js-filter-btn').sideFilter();
  $('.js-change-toggle').changeToggle();
  $('.js-slides').slides();
  $('.js-focus-to').focusTo();
  $('.js-cookies-banner-toggle').cookiesBanner();
  $('.js-pdp-zoom').slides({
    prevArrow: $('#js-pdp-zoom-prev'),
    nextArrow: $('#js-pdp-zoom-next'),
  });

  $('.js-carousel__featured').slickAccessible({
    infinite: false,
    nextArrow: slickArrow('next', 'next', 'arrow-right--stem'),
    prevArrow: slickArrow('previous', 'prev', 'arrow-left--stem'),
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 899,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 549,
        settings: {
          slidesToShow: 2.5,
        },
      },
    ],
    accessibility: true,
  });
  $('.js-hp-section').lazyAjax({
    bind: event,
    delay: 0,
    afterLoad: function afterLoad() {
      $('.js-carousel__obsessions').slickAccessible({
        infinite: false,
        slidesToShow: 4,
        nextArrow: slickArrow('next', 'next', 'arrow-right--stem'),
        prevArrow: slickArrow('previous', 'prev', 'arrow-left--stem'),
        responsive: [
          {
            breakpoint: 899,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 549,
            settings: {
              arrows: false,
              slidesToShow: 2.5,
            },
          },
        ],
        accessibility: true,
      });
    },
  });
  $('.js-carousel__prod-recs').slickAccessible({
    lazyLoad: 'ondemand',
    infinite: false,
    nextArrow: slickArrow('next', 'next', 'arrow-right--stem'),
    prevArrow: slickArrow('previous', 'prev', 'arrow-left--stem'),
    slidesToShow: 5,
    responsive: [
      {
        breakpoint: 899,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 549,
        settings: {
          arrows: false,
          slidesToShow: 2.5,
        },
      },
    ],
    accessibility: true,
  });
  $('.js-carousel__shop').slickAccessible({
    dots: true,
    dotsClass: 'image-carousel__dots',
    nextArrow: slickArrow('next', 'next', 'arrow-right--stem'),
    prevArrow: slickArrow('previous', 'prev', 'arrow-left--stem'),
    slidesToScroll: 4,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 899,
        settings: {
          dots: true,
          infinite: false,
          slidesToScroll: 3,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 549,
        settings: {
          arrows: false,
          dots: false,
          infinite: false,
          slidesToScroll: 1,
          slidesToShow: 1.25,
        },
      },
    ],
    accessibility: true,
  });

  // Global Banner slider
  const bannerSlideshow = $('.js-slideshow');
  if (bannerSlideshow.children('.banner--slider-list__item').length > 1) {
    bannerSlideshow.slick({
      arrows: true,
      prevArrow: '.banner__slick-prev',
      nextArrow: '.banner__slick-next',
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            autoplay: true,
            autoplaySpeed: 6000,
            slidesToShow: 1,
          },
        },
      ],
    });
    $('.banner__slick-next, .banner__slick-prev').on('click', () => {
      bannerSlideshow.slick('slickPause');
    });
  } else {
    $('.banner__slick-next, .banner__slick-prev').hide();
    $('.banner--slider-list').show();
  }

  $('.js-goto-slide').gotoSlide();
  noFocus();
  initReveals();
  imageCarousel();
  sizeguideTable();
  window.applyTelephoneMask();
  // fixedButtonScroll();

  // Hearting feature can be added to backend logic for hearting products
  window.bindFavoriteAnimationEvent = () => {
    // DO NOT CHANGE TO () =>
    $('.js-heart-button').on('click', function heartProduct() {
      const $this = $(this);
      const $heartOutline = $this.find('.icon--heart-emoji-outline');
      const $heartFill = $this.find('.icon--heart-emoji-fill');

      if ($heartOutline.hasClass('u-hide')) {
        $heartFill.addClass('u-hide').removeClass('heartbeat');
        $heartOutline.removeClass('u-hide');
      } else {
        $heartOutline.addClass('u-hide');
        $heartFill.removeClass('u-hide').addClass('heartbeat');
      }
    });
  };
  window.bindFavoriteAnimationEvent();
  removeWhiteSpacesAndLowerCase();
  setTimeout(() => slickResetTabIndex($('.js-carousel__featured')), 500);
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/modules.js